<template>
  <div id="login-screen">
    <div class="login-form-wrapper">
      <div class="login-form-header">
        <p class="login-form-header-text kaushan-font">
          {{ $t("loginScreen.form.title") }}
        </p>
      </div>
      <div class="login-form">
        <div class="input-fields">
          <div class="username-wrapper">
            <basic-input
              width="100%"
              :placeholder="$t('loginScreen.form.username')"
              :label="$t('loginScreen.form.username')"
              :type="'text'"
              class="username"
              v-model="credentials.username"
            />
          </div>
          <div class="password-wrapper">
            <basic-input
              width="100%"
              :placeholder="$t('loginScreen.form.password')"
              :label="$t('loginScreen.form.password')"
              :type="'password'"
              class="password"
              v-model="credentials.password"
            />
          </div>
        </div>
        <div class="login-button-wrapper">
          <rounded-button
            position="center"
            width="80%"
            :loading="isLoading"
            :disabled="!buttonIsValid || isLoading"
            @click="loginButtonClicked"
          >
            <template>
              {{ $t("loginScreen.form.button") }}
            </template>
          </rounded-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ValidatorMixin from "@/mixins/ValidatorMixin";
import { mapActions } from "vuex";
export default {
  name: "LoginScreen",
  mixins: [ValidatorMixin],
  data() {
    return {
      isLoading: false,
      credentials: {
        username: "",
        password: ""
      }
    };
  },
  mounted() {
    window.addEventListener("keyup", this.handleKeyup);
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.handleKeyup);
  },
  methods: {
    ...mapActions({
      userLogin: "user/userLogin"
    }),
    handleKeyup(evt) {
      if (evt.key === "Enter") {
        this.loginButtonClicked();
      }
    },
    loginButtonClicked() {
      this.isLoading = true;
      if (this.buttonIsValid) {
        this.userLogin(this.credentials)
          .then(res => {
            if (res.status === "OK") {
              this.isLoading = false;
              let url = "/";
              // if (res.data.role === this.$variables.roleName.ADMIN) {
              //   url = "/";
              // } else if (res.data.role === this.$variables.roleName.DRIVER) {
              //   url = "/delivery";
              // } else if (res.data.role === this.$variables.roleName.STOREMAN) {
              //   url = "/wash";
              // }
              this.$router.replace(url);
            } else {
              this.isLoading = false;
              this.$eventBus.showDropdownNoti({
                icon: "error",
                title: res.errorTitle,
                text: res.errorMessage
              });
            }
          })
          .catch(() => {
            this.isLoading = false;
            this.$eventBus.showDropdownNoti({
              icon: "error",
              title: this.$t("loginScreen.loginError.noti.title"),
              text: this.$t("loginScreen.loginError.noti.text")
            });
          });
      }
    }
  },
  computed: {
    buttonIsValid() {
      return (
        this.credentials.username.length > 0 &&
        this.credentials.password.length > 0
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#login-screen {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .login-form-wrapper {
    padding: 30px 10px 5px 10px;
    position: relative;
    display: flex;
    justify-content: center;
    height: fit-content;
    max-width: 450px;
    width: 90vw;
    background: #fff;
    box-shadow: $basic-shadow;
    border-radius: 10px;
    .login-form-header {
      height: 40px;
      width: 40vw;
      min-width: 200px;
      max-width: 250px;
      border-radius: 10px;
      position: absolute;
      box-shadow: $basic-shadow;
      background-color: $color-light-primary;
      border: 1px solid $color-primary;
      margin-top: -50px;
      display: flex;
      justify-content: center;
      align-items: center;
      & p {
        color: white;
        font-size: 20px;
      }
    }
    .login-form {
      width: 80%;
      height: 100%;
      .username-wrapper {
        margin-top: 20px;
        margin-bottom: 20px;
      }
      .password-wrapper {
        margin-bottom: 30px;
      }
    }
    .login-button-wrapper {
      margin-bottom: 30px;
    }
  }
}
@media (max-width: 450px) {
  .login-form {
    width: 100% !important;
  }
}
@media (max-height: 700px) {
  .login-form {
    .username-wrapper {
      margin-top: 30px !important;
      margin-bottom: 20px !important;
    }
    .password-wrapper {
      margin-bottom: 40px !important;
    }
  }
}
</style>
